module.exports = __webpack_public_path__ + "static/media/POS_01_C.48a4f502.png";